
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post138() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi gente, tenho diabetes tipo 2 e tomo xgduo. Alguém que usa esse medicamente teve algum diagnóstico de sangue na urina?</title>
        <meta 
          name="description" 
          content="Oi gente, tenho diabetes tipo 2 e tomo xgduo. Alguém que usa esse medicamente teve algum diagnóstico de sangue na urina?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Marcos Rosebrock &#183; 20/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi gente, tenho diabetes tipo 2 e tomo xgduo. Alguém que usa esse medicamente teve algum diagnóstico de sangue na urina?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/138')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Marcos,<br/><br/>Obrigada por compartilhar sua preocupação com a gente. Sangue na urina não é algo comum e merece atenção. É possível que seja um efeito colateral do medicamento que você está tomando, mas isso não é algo para negligenciar.<br/><br/>É muito importante que você informe seu médico imediatamente sobre este sintoma. Somente ele pode avaliar corretamente a situação e decidir se é necessário ajustar sua medicação ou investigar outras possíveis causas.<br/><br/>Enquanto você não consegue falar com seu médico, procure beber bastante água e evite esforços físicos intensos.<br/><br/>Fique atento e cuide-se!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 20/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/138')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/6-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Cuidando do colesterol alto  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Tenho colesterol alto faz alguns anos, e quando fui diagnosticado pela primeira vez foi um pouco de choque, mas aprendi a lidar com doença e hoje meu colesterol está em níveis normais devido às mudanças que fiz de estilo de vida.<br/><br/>No fim, tenho certeza que o diagnóstico veio para o bem, pelo seguinte motivo: nos meus estudos aprendi que cerca de 85% das pessoas com mais de 50 anos (como é meu caso agora) tem algum bloqueio significativo em suas artérias, porém sem nenhum sintoma. Em dois terços dos casos (30% das vezes) o primeiro sintoma é um ataque do coração. Eu poderia estar nessa estatística, mas não estou, porque fui diagnosticado antes e mudei meu estilo de vida!<br/><br/>Duas dicas que acho que são importantes para quem descobriu que tem essa doença ou que está preocupado com seu colesterol:<br/><br/>1 - Saiba a diferença entre colesterol HDL (colesterol bom) e LDL (colesterol ruim), e como fazer para aumentar o colesterol bom e diminuir o ruim,.<br/><br/>2 - Tem 3 coisas que temos controle, e que afetam nosso colesterol e nossa saúde: nosso peso, o que comemos e nossa prática de exercícios físicos. Essas coisas estão no nosso controle e são nossa responsabilidade.<br/><br/>Esses pontos foram os que fizeram a diferença na minha saúde, e talvez possam fazer também na sua!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/6')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Bruna Almeida &#183; 16/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/112-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal boa tarde minha hemoglobina glicada deu 13.5, ta muito alta?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/112')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Maria Schwed &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/18-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes de jejum  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia boa semana a todos
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/18')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Camila da Silveira &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/142-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Hoje fui no meu endocrinologista e ele mudou meu medicamento que já tomava faz tempo cloridrato de pioglitasona 15mg por forxiga 10mg. Reparei que a diferença de preço é grande. Esse Forxiga é muito melhor?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/142')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/5-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Experiência lidando com diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.<br/><br/>Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.<br/><br/>Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. <br/><br/>Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.<br/><br/>A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. <br/><br/>O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.<br/><br/>Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.<br/><br/>Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/5')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
